import Api from "app/services/common/Api";
import ContractModel from "app/model/cb/contractModel";
import { FileInfoModel } from "app/model/common/file";
import ContractPPAModel from "app/model/cb/contractPPAModel";
import { ResponseChartData } from "app/model/response-chart";

export class ContractService extends Api {
  private static service: ContractService;

  public static getInstance(): ContractService {
    if (!ContractService.service) {
      ContractService.service = new ContractService();
    }
    return ContractService.service;
  }

  public async cntrStatistics() {
    const url = process.env.REACT_APP_URL_CB + '/cntr/status';
    return await super.get<ResponseChartData[]>(url);
  }

  public async detail(cntrId: string) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/cntr';
    return await super.get<ContractModel>(url, { cntrNo: cntrId });
  }

  public async save(form: FormData) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/cntr';
    return await super.post<ContractModel>(url, form);
  }

  public async updateState(data: FormData) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/status';
    return await super.post<ContractModel>(url, data);
  }

  public async updateOtran(data: ContractModel) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/otran';
    return await super.put<ContractModel>(url, data);
  }

  public async history(data: ContractModel) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/history';
    return await super.get<ContractModel[]>(url, { cntrNo: data.cntrNo });
  }

  public async downloadFile(file: FileInfoModel) {
    const param = {
      filePath: file.pthNm,
      fileName: file.fileNm,
      originalFileName: file.realNm,
    };
    const url = process.env.REACT_APP_URL_CB + '/files/file';
    return await super.download(url, param);
  }

  public async saveBroker(form: FormData) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/trd';
    return await super.post<ContractModel>(url, form);
  }

  public async saveCorp(form: FormData) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/corp';
    return await super.post<ContractModel>(url, form);
  }

  public async updateReject(form: ContractModel) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/ppa/reject';
    return await super.put<ContractModel>(url, form);
  }

  public async updateCompletePpa(cntrNo: string) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/ppa/complete';
    return await super.put<ContractModel>(url, cntrNo);
  }

  public async brokerInstt(data: ContractPPAModel) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/trd/instt';
    return await super.put<ContractPPAModel>(url, data);
  }

  public async corpInstt(data: ContractPPAModel) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/corp/instt';
    return await super.put<ContractPPAModel>(url, data);
  }

  public async saveBrokerSign(form: FormData) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/trd/sign';
    return await super.post<ContractPPAModel>(url, form);
  }

  public async saveCorpSign(form: FormData) {
    const url = process.env.REACT_APP_URL_CB + '/cntr/corp/sign';
    return await super.post<ContractPPAModel>(url, form);
  }
}
